// Сховище тостів поза React: toast.success('Збережено') можна викликати звідусіль (мутації, обробники API).
// Рендерить <ToastProvider>/<ToastViewport> з src/ui/Toast.tsx.

export type ToastTone = 'info' | 'success' | 'warning' | 'danger';

export interface ToastItem {
  id: number;
  tone: ToastTone;
  title: string;
  description?: string;
  /** мс; 0 — не зникає сам. */
  duration: number;
  action?: { label: string; onClick: () => void };
}

export interface ToastInput {
  title: string;
  description?: string;
  duration?: number;
  action?: { label: string; onClick: () => void };
}

type Listener = (items: ToastItem[]) => void;

let items: ToastItem[] = [];
let seq = 0;
const listeners = new Set<Listener>();

function emit() {
  for (const l of listeners) l(items);
}

export function subscribeToasts(listener: Listener): () => void {
  listeners.add(listener);
  listener(items);
  return () => {
    listeners.delete(listener);
  };
}

export function dismissToast(id: number): void {
  items = items.filter((t) => t.id !== id);
  emit();
}

function show(tone: ToastTone, input: ToastInput | string): number {
  const data = typeof input === 'string' ? { title: input } : input;
  // Однакові повідомлення підряд не дублюємо.
  const same = items.find((t) => t.title === data.title && t.description === data.description && t.tone === tone);
  if (same) return same.id;
  const id = ++seq;
  const duration = data.duration ?? (tone === 'danger' ? 7000 : 4000);
  items = [...items.slice(-4), { id, tone, duration, ...data }];
  emit();
  if (duration > 0) setTimeout(() => dismissToast(id), duration);
  return id;
}

export const toast = {
  info: (input: ToastInput | string) => show('info', input),
  success: (input: ToastInput | string) => show('success', input),
  warning: (input: ToastInput | string) => show('warning', input),
  error: (input: ToastInput | string) => show('danger', input),
  dismiss: dismissToast,
};

export type Toaster = typeof toast;
